import React from 'react';
import './Structure.css'; // 使用与 CultureLab 相同的 CSS 文件

function Structure() {
  return (
    <div className="structure-container">
      <h1>实验室组织结构</h1>
      <img src="/zuzhi.jpg" alt="组织结构图" className="structure-image" />
    </div>
  );
}

export default Structure;